var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("DiscreteScaleEditor", {
        attrs: { viewModel: _vm.discreteScaleEditor },
        on: {
          "create-scale": _vm.handleCreateWorkspaceScaleCommand,
          "update-scale": _vm.handleUpdateWorkspaceScaleCommand,
          "delete-scale": _vm.handleDeleteWorkspaceScaleCommand,
        },
      }),
      _vm._v(" "),
      _c("WorkspaceNavigation", {
        attrs: {
          workspaceId: _vm.workspaceId,
          workspaceName: _vm.workspaceName,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success dropdown-toggle",
                    staticStyle: { padding: "0.7em 2em" },
                    attrs: { type: "button", "data-toggle": "dropdown" },
                  },
                  [
                    _vm._v(
                      "\n                        Create scale\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    staticStyle: { "max-height": "300px", overflow: "auto" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "dropdown-item my-2 dropdown-item-template",
                        on: {
                          click: function ($event) {
                            return _vm.showScaleCreator(null)
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("Blank")]),
                        _c("br"),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v("Create scale template from scratch"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _vm.tchTemplates
                      ? _c(
                          "div",
                          [
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("TransparentChoice's Templates"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.tchTemplates, function (t) {
                              return _c(
                                "a",
                                {
                                  staticClass:
                                    "dropdown-item dropdown-item-template my-2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showScaleCreator(t)
                                    },
                                  },
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(t.Name))]),
                                  _c("br"),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(t.Description)),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _vm.scales
            ? _c("div", { staticClass: "mt-3" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.scalesView, function (s) {
                    return _c(
                      "div",
                      { key: s.Id, staticClass: "col-sm-6 col-md-4" },
                      [
                        _c("div", { staticClass: "tile bg-color-gray5" }, [
                          _c("div", { staticClass: "pointer float-right" }, [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.showScaleEditor(s)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fa fa-pencil" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h4",
                            {
                              staticClass: "text-ellipsis fg-color-gray",
                              staticStyle: { "margin-top": "7px" },
                            },
                            [_c("span", [_vm._v(_vm._s(s.Name))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "small",
                            { staticClass: "text-ellipsis fg-color-gray1" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(s.LevelsDescription) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Scales")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }